import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchCommon, fetchDownloadBlobUrl} from '../../../../../helpers/FetchUtils';
import {
    ACC_CORP_LOGO_VIEW
} from './constants';
import {
    accountCorpLogoViewSuccess,
    accountCorpLogoViewFail
} from './actions';
import {catchError} from "../../../../../util/ErrorCatchUtils";
import {layoutMainSignCheck} from "../../../layouts/main/actions";

/**
 *
 */
function* accountCorpLogoView({payload: {corpId}}) {
    try {
        const res1 = yield call(fetchCommon,
            '/api/account/corp/logo/download/' + corpId,
            {method: "GET"});
        if (res1.success) {
            const downloadId = res1.data.downloadId;
            let res2 = yield call(fetchDownloadBlobUrl,
                '/api/storage/download/' + downloadId,
                {method: "GET"});
            if (res2.success) {
                yield put(accountCorpLogoViewSuccess(res2));
            } else {
                yield put(accountCorpLogoViewFail(res2));
            }
        } else {
            yield put(accountCorpLogoViewFail(res1));
        }
    } catch (error) {
        yield put(layoutMainSignCheck(catchError(error)));
        yield put(accountCorpLogoViewFail(catchError(error)));
    }
}

export function* accountCorpLogoViewWatcher() {
    yield  takeEvery(ACC_CORP_LOGO_VIEW, accountCorpLogoView);
}

function* AccountCorpLogoViewSaga() {
    yield all([
        fork(accountCorpLogoViewWatcher)]);
}

export default AccountCorpLogoViewSaga;
